/*
 * @Author: FRX
 * @Date: 2022-07-01 11:12:53
 * @LastEditors: FRX
 * @LastEditTime: 2022-08-22 10:01:16
 * @Description: 
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/layout/index.vue'
import Login from '@/views/login/Login.vue'
import Welcome from '@/views/home/welcome.vue'
import Identify from '@/views/login/Identify.vue'
import routes from '@/router/routes.js'
import h5Routes from '@/router/h5Routes.js'
import http from '@/assets/js/httpUtil.js'
import config from '@/config/api.js'
Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const title = process.env.VUE_APP_TITLE // 标题名称

const route = [
    {
        path: '/home',
        name: 'Layout',
        component: Layout,
        children: [...routes]
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    // OA跳转中专页面
    {
        path: '/identify',
        name: 'Identify',
        component: Identify
    },
    ...h5Routes, // h5路由
    {
        path: '/',
        redirect: '/login'
    }
]

const router = new VueRouter({
    // mode: 'history',
    // base: process.env.BASE_URL,
    routes: route,
})

// 路由钩子
router.beforeEach((to, from, next) => {
    // 标题修改
    if (title && to?.meta?.title) document.title = title + '-' + to.meta.title
    else if (title) document.title = title
    next()
})


export default router